import { LiquidProduct } from "@sections/product";
import { h, FunctionComponent, Fragment } from "preact";
import { useState, useRef, useEffect } from "preact/hooks";

declare global {
  interface Window {
    BIS: {
      create: (
        email: string,
        variantId: string,
        productId: number,
      ) => Promise<{ status: string; message: string }>;
    };
  }
}

interface ProductNotifyMeProps {
  productData: string;
  isVisible: string;
  productId: string;
  variantId: string;
}

const ProductNotifyMe: FunctionComponent<ProductNotifyMeProps> = (props) => {
  const isVisibleProp: boolean = props.isVisible === "true";
  const product: LiquidProduct = JSON.parse(props.productData);
  const variantId: string = props.variantId;

  const variantSelect = useRef(null);
  const emailInput = useRef(null);
  const submitButton = useRef(null);

  const [isVisible, setIsVisible] = useState(isVisibleProp);

  const closeModal = (event: Event) => {
    event.preventDefault();
    const target =
      (event.target as HTMLElement) ||
      (event.target as unknown as HTMLElement)!.closest(".button");
    target
      ?.closest("uwp-product-notify-me")
      ?.setAttribute("is-visible", "false");
  };

  useEffect(() => {
    if (isVisible !== isVisibleProp) {
      setIsVisible(isVisibleProp);
    }
  }, [props.isVisible, isVisible]);

  const handleSendToBIS = (data: { status: string; message: string }) => {
    const buttonElement = submitButton.current as unknown as HTMLElement;

    buttonElement.textContent =
      data.status === "OK"
        ? window.themeVars.strings.product.notifyMeModalSuccess
        : window.themeVars.strings.product.notifyMeModalError;

    setTimeout(() => {
      buttonElement.textContent = "Notify Me";
    }, 1000);
  };

  const sendToBIS = () => {
    const email = (emailInput.current as unknown as HTMLInputElement)!.value;
    const variantId = (variantSelect.current as unknown as HTMLSelectElement)
      .value;
    const productId = product.id;
    window.BIS.create(email, variantId, productId).then(handleSendToBIS);
  };

  let productImage = product.featured_image;

  if (productImage === undefined) {
    productImage = product.images[0].src;
  }

  return (
    <div
      className={`product__notify-modal__container ${isVisible ? "active" : ""}`}
    >
      <div className="product__notify-modal__wrapper">
        <div className="product__notify-modal__header">
          <h4>{window.themeVars.strings.product.notifyMeModalTitle}</h4>
          <button
            className="product__notify-modal__close"
            onClick={closeModal}
            dangerouslySetInnerHTML={{
              __html: window.themeVars.icons.close,
            }}
          />
        </div>

        <div className="product__notify-modal__body">
          <div className="product__notify-modal__image">
            <img src={productImage} alt={product.title} />
            <h2 className="product__notify-modal__title">{product.title}</h2>
          </div>

          <p className="product__notify-modal__text">
            {window.themeVars.strings.product.notifyMeModalText}
          </p>

          {product.variants.length && (
            <Fragment>
              <p>{window.themeVars.strings.product.notifyMeModalOption}:</p>

              <select
                name="Unavailable Variants"
                data-variant
                className="product__notify-modal__select"
                ref={variantSelect}
                value={variantId}
              >
                {product.variants.map(
                  (variant) =>
                    !variant.available && (
                      <option
                        key={variant.id}
                        value={variant.id}
                        selected={variant.id === variantId}
                      >
                        {variant.title}
                      </option>
                    ),
                )}
              </select>
            </Fragment>
          )}

          <p>{window.themeVars.strings.product.notifyMeModalEmail}:</p>

          <input
            type="email"
            name="email"
            ref={emailInput}
            required
            placeholder="Email Address"
            className="product__notify-modal__sign-up"
          />

          <button
            className="product__notify-modal__button btn btn-black"
            onClick={sendToBIS}
            ref={submitButton}
          >
            {window.themeVars.strings.product.notifyMeModalSubmit}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductNotifyMe;
